import { AmountText } from '@repo/ui/amount-text';
import { useTranslations } from 'next-intl';
import { type PaymentTypes } from '@/server-actions/payment-methods';
import FailureMessage from './failure-message';
import SuccessMessage from './success-message';

interface PaymentStatusProps {
  paymentType: PaymentTypes;
  amount: number;
  currency: string;
  goBack: () => void;
  status: string;
}

const PaymentStatus = ({ paymentType, amount, currency, goBack, status }: PaymentStatusProps) => {
  const t = useTranslations(paymentType);

  const subTitleRenderer = (subTitleKey: string) =>
    t.rich(subTitleKey, {
      amount: () => (
        <AmountText
          value={currency === 'USD' ? amount * 100 : amount}
          currency={currency}
        />
      ),
    });

  switch (status) {
    case 'SUCCESS':
      return (
        <SuccessMessage
          paymentType={paymentType}
          title={t('success-title')}
          subTitle={subTitleRenderer('success-subtitle')}
        />
      );
    case 'ERROR':
      return (
        <FailureMessage
          paymentType={paymentType}
          title={t('failure-title')}
          subTitle={subTitleRenderer('failure-subtitle')}
          goBack={goBack}
        />
      );
    default:
      return null;
  }
};

export default PaymentStatus;
